"use client"

import { Skeleton } from "antd"
import { FC } from "react"

type SelectDateProps = {
  size?: 'small' | 'default'
}

const SelectRangeDateSkeleton: FC<SelectDateProps> = ({ size = 'default' }) => {
  const isSmall = size === 'small'

  if (isSmall) {
    return (
      <div className="home__searching--hero-dates-bar home__searching--hero-dates-bar--compact" style={{ minHeight: '4.4rem' }}>
        <div className="home__searching--hero-dates-segment home__searching--hero-dates-segment--from home__searching--hero-dates-segment--active">
          <div className="home__searching--hero-dates-segment-content home__searching--hero-dates-segment-content--compact">
            <Skeleton paragraph={false} active styles={{ title: { height: '1.2rem', width: '6rem', margin: 0 } }} />
            <Skeleton paragraph={false} active styles={{ title: { height: '1.8rem', width: '80%', margin: '0.4rem 0 0' } }} />
          </div>
        </div>
        <div className="home__searching--hero-dates-divider" aria-hidden />
        <div className="home__searching--hero-dates-segment home__searching--hero-dates-segment--to home__searching--hero-dates-segment--active">
          <div className="home__searching--hero-dates-segment-content home__searching--hero-dates-segment-content--compact">
            <Skeleton paragraph={false} active styles={{ title: { height: '1.2rem', width: '6rem', margin: 0 } }} />
            <Skeleton paragraph={false} active styles={{ title: { height: '1.8rem', width: '80%', margin: '0.4rem 0 0' } }} />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="home__searching--placement">
      <Skeleton paragraph={false} active styles={{ title: { height: '2.1rem', width: '100%', margin: 0 } }} />
    </div>
  )
}

export default SelectRangeDateSkeleton
